"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _default = {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var convertToBetaIcons = function convertToBetaIcons(icon) {
      switch (icon) {
        case 'g-dashboard':
          return 'fas fa-tachometer-alt';

        case 'g-agent':
          return 'fas fa-user';

        case 'settings':
          return 'fas fa-cogs';

        case 'g-organization':
          return 'fas fa-building';

        case 'g-finance':
          return 'fas fa-file-invoice-dollar';

        case 'g-sms':
          return 'fas fa-envelope';

        case 'g-channel':
          return 'fas fa-satellite-dish';

        case 'g-report':
          return 'fas fa-file-invoice';

        case 'g-history':
          return 'fas fa-history';

        case 'g-system':
          return 'fas fa-tv';

        case 'g-schedulling':
          return 'fas fa-calendar-alt';

        default:
          return 'fas fa-bars';
      }
    };

    var _context$props = context.props,
        icon = _context$props.icon,
        title = _context$props.title;
    var vnodes = [];

    if (icon) {
      if (context.parent.$store.getters.themeConf === 'beta') {
        vnodes.push(h("i", {
          "class": [convertToBetaIcons(icon), 'icon-fa'],
          "style": "margin-right: 15px"
        }));
      } else if (icon.includes('el-icon')) {
        vnodes.push(h("i", {
          "class": [icon, 'sub-el-icon']
        }));
      } else {
        vnodes.push(h("svg-icon", {
          "attrs": {
            "icon-class": icon
          }
        }));
      }
    }

    if (title) {
      vnodes.push(h("span", {
        "slot": 'title'
      }, [" ", title, " "]));
    }

    return vnodes;
  }
};
exports.default = _default;